import {
  TrendDirectionName,
  useGetTrendDirectionDropDownQuery
} from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: TrendDirectionName;
  displayName: string;
}

export function useQuery() {
  const tuple = useGetTrendDirectionDropDownQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.trendDirection?.map((node) => ({
        id: node.id,
        name: node.name,
        displayName: node.displayName
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
